import { Collapsible } from '~/components/ui/Collapsible';
import { Terminal } from '~/components/workbench/terminal/Terminal';
import type { PotentialSupabaseFunctionProblem } from '~/types/chat';

export function SupabaseFunctionRenderer(error: PotentialSupabaseFunctionProblem) {
  return (
    <div className="flex flex-col gap-2">
      <Collapsible
        defaultOpen={false}
        titleClassName="flex-col"
        title={
          <div className="[&>pre]:px-2 [&>pre]:py-2 text-xs w-full">
            <pre>
              <div className="flex items-center gap-1">
                <div className="text-lg i-ph:x text-bolt-elements-icon-error"></div>
                Supabase Edge Function {error.functionSlug} error
              </div>
            </pre>
          </div>
        }
      >
        <Terminal className="grow-1 h-[150px]" readonly>
          {[error.message, '', 'Logs:', error.logs?.join('\n') || 'No logs'].join('\n')}
        </Terminal>
      </Collapsible>
    </div>
  );
}
